import Modal from '../modal/modal';
import Table from '../table/table';
import {
  BasicTableDataRow,
  FormTemplate,
  TableCellContentAlignEnum,
} from '@employ-engage/data';
import Tooltip from '../tooltip/tooltip';
import { useEffect, useState } from 'react';
import AddTemplateToCompanyModal from '../add-template-to-company-modal/add-template-to-company-modal';
import { useTranslation } from 'react-i18next';

export interface TemplateMarketplaceModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export function TemplateMarketplaceModal({
  open,
  setOpen,
}: TemplateMarketplaceModalProps) {
  const { t } = useTranslation(['common']);
  const [surveyTemplates] = useState<FormTemplate[]>([]);
  const [isAddTemplateToCompanyModalOpen, setIsAddTemplateToCompanyModalOpen] =
    useState<boolean>(false);
  const [
    templateSelectedForAddingToCompanyCollection,
    setTemplateSelectedForAddingToCompanyCollection,
  ] = useState<FormTemplate | null>(null);

  useEffect(() => {
    // const q = query(getGlobalSurveyTemplatesCollectionRef());
    // const unsubscribe = onSnapshot(q, (querySnapshot) => {
    //   const surveyTemplates: FirestoreSurveyTemplate[] = [];
    //   querySnapshot.forEach((doc) => {
    //     surveyTemplates.push(FirestoreSurveyTemplate.fromFirestore(doc, {}));
    //   });
    //   setSurveyTemplates(surveyTemplates);
    // });
    // return () => unsubscribe();
  }, []);

  return (
    <Modal
      panelClassName="bg-light-primaryBackground w-3/4"
      open={open}
      setOpen={setOpen}
    >
      <Table
        label={t('Template Marketplace')}
        headerList={[
          {
            id: 'name',
            headerLabel: t('Name'),
          },
          {
            id: 'options',
            headerLabel: t('Options'),
            alignment: TableCellContentAlignEnum.CENTER,
          },
          {
            id: 'actions',
            headerLabel: t('Actions'),
          },
        ]}
        dataList={surveyTemplates as unknown as BasicTableDataRow[]}
        mapData={(row, index) => {
          return {
            index,
            id: row.id,
            name: row.name,
            options: (
              <div className="flex justify-center space-x-1">
                {!!row.isAnonymous && (
                  <Tooltip label={t('Anonymous for All Respondents')}>
                    <button className="cursor-default">
                      <i className="fa-solid fa-question text-orange-500" />
                    </button>
                  </Tooltip>
                )}
                {!!row.isInfinitelyRespondable && (
                  <Tooltip label={t('Infinite Responses Allowed')}>
                    <button className="cursor-default">
                      <i className="fa-solid fa-infinity text-purple-500" />
                    </button>
                  </Tooltip>
                )}
              </div>
            ),
            actions: (
              <div className="flex justify-end">
                <Tooltip label={t('Add Template to Company Collection')}>
                  <button
                    onClick={() => {
                      setTemplateSelectedForAddingToCompanyCollection(
                        row as unknown as FormTemplate
                      );
                      setIsAddTemplateToCompanyModalOpen(true);
                    }}
                  >
                    <i className="fa-solid fa-plus text-light-primaryText dark:text-dark-primaryText hover:text-blue-500 hover:dark:text-blue-500" />
                  </button>
                </Tooltip>
              </div>
            ),
          };
        }}
      />
      <AddTemplateToCompanyModal
        open={isAddTemplateToCompanyModalOpen}
        setOpen={setIsAddTemplateToCompanyModalOpen}
        templateSelectedForAddingToCompanyCollection={
          templateSelectedForAddingToCompanyCollection
        }
      />
    </Modal>
  );
}

export default TemplateMarketplaceModal;
